import React from 'react'
import PropTypes from 'prop-types'
import {AspectRatio, Box, Flex, Img, Text, useMultiStyleConfig} from '@chakra-ui/react'
import SanitizedHtml from '../html-sanitizer'

const GridCard = ({image, onClick, title, variant}) => {
    const styles = useMultiStyleConfig('GridCard', {variant})
    return (
        <Flex {...styles.cardContainer} data-testid="grid-card" onClick={onClick}>
            <Box {...styles.imgWrapper}>
                <AspectRatio ratio={1.25} width="100%" height="auto">
                    {image ? (
                        <Img src={image} {...styles.tileImage} />
                    ) : (
                        <Img
                            src={'https://dam.delonghigroup.com/800x640/assets/244948'} //placeholder in case of image undefined
                            {...styles.tileImage}
                        />
                    )}
                </AspectRatio>
                <Box {...styles.gridCardOverlay} />
            </Box>
            <SanitizedHtml as={Text} html={title} {...styles.cardText} sanitize={true} />
        </Flex>
    )
}

GridCard.propTypes = {
    image: PropTypes.string,
    onClick: PropTypes.func,
    title: PropTypes.string,
    variant: PropTypes.string,
}

export default GridCard
